import { IconSearch } from '@maia/icons';
import { Input, Pagination, Table } from '@maia/ui';
import { useQuery } from '@tanstack/react-query';
import { debounce } from 'es-toolkit';
import { useEffect } from 'react';
import { Activities, getActivitiesOptions } from './queryOptions';
import { useFilter } from '../../../utils/filter/filter';
import { useActivitiesTable } from './tableOptions';
import { useParams } from '@tanstack/react-router';

type ActivitiesTableProps = {
  activities: Activities;
};

export function ActivitiesTable(props: ActivitiesTableProps) {
  const { activities } = props;
  const { guid } = useParams({
    from: '/_authenticated/insurances/$guid/_layout/activities',
  });
  const {
    state,
    dispatch: setSearch,
    mappedState,
  } = useFilter('/insurances/$guid/activities');
  const { data } = useQuery(
    getActivitiesOptions(guid, mappedState, activities),
  );

  const table = useActivitiesTable(data ?? activities);

  const { sorting } = table.getState();

  useEffect(() => {
    setSearch({ type: 'setSort', payload: sorting });
  }, [setSearch, sorting]);

  const debouncedQuery = debounce(
    (payload: string) => setSearch({ type: 'setQuery', payload }),
    500,
  );

  return (
    <Table
      table={table}
      className="grid-cols-[min-content_auto_min-content_min-content]"
      filterSlot={
        <div className="flex gap-x-24">
          <Input
            icon={<IconSearch />}
            placeholder="Zoeken"
            className="w-full max-w-[550px] mr-auto"
            onChange={(event) => debouncedQuery(event.target.value)}
            defaultValue={state.search}
          />
        </div>
      }
      paginationSlot={
        data?.pagination ? (
          <Pagination
            {...data.pagination}
            onLimitChange={(limit) =>
              setSearch({ type: 'setLimit', payload: limit })
            }
            onPageChange={(page) =>
              setSearch({ type: 'paginate', payload: page })
            }
          />
        ) : null
      }
    />
  );
}
